import React from "react";

const Header = ({ title }) => {
  return (
    <header className="row d-flex justify-content-center header">
      <h1 className="title text-center text-uppercase pt-4 pb-4">{title}</h1>
      <div className="divider--title m-5"></div>
    </header>
  );
};

export default Header;
